import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Banks\ProjectsController::index
* @see app/Http/Controllers/Banks/ProjectsController.php:22
* @route '//bank.finesthub.de/financing-negotiations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/financing-negotiations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\ProjectsController::index
* @see app/Http/Controllers/Banks/ProjectsController.php:22
* @route '//bank.finesthub.de/financing-negotiations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\ProjectsController::index
* @see app/Http/Controllers/Banks/ProjectsController.php:22
* @route '//bank.finesthub.de/financing-negotiations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::index
* @see app/Http/Controllers/Banks/ProjectsController.php:22
* @route '//bank.finesthub.de/financing-negotiations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showNegotiation
* @see app/Http/Controllers/Banks/ProjectsController.php:89
* @route '//bank.finesthub.de/financing-negotiations/{projectSuggestion}'
*/
export const showNegotiation = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showNegotiation.url(args, options),
    method: 'get',
})

showNegotiation.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/financing-negotiations/{projectSuggestion}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showNegotiation
* @see app/Http/Controllers/Banks/ProjectsController.php:89
* @route '//bank.finesthub.de/financing-negotiations/{projectSuggestion}'
*/
showNegotiation.url = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { projectSuggestion: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { projectSuggestion: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            projectSuggestion: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        projectSuggestion: typeof args.projectSuggestion === 'object'
        ? args.projectSuggestion.id
        : args.projectSuggestion,
    }

    return showNegotiation.definition.url
            .replace('{projectSuggestion}', parsedArgs.projectSuggestion.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showNegotiation
* @see app/Http/Controllers/Banks/ProjectsController.php:89
* @route '//bank.finesthub.de/financing-negotiations/{projectSuggestion}'
*/
showNegotiation.get = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showNegotiation.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showNegotiation
* @see app/Http/Controllers/Banks/ProjectsController.php:89
* @route '//bank.finesthub.de/financing-negotiations/{projectSuggestion}'
*/
showNegotiation.head = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showNegotiation.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::suggested
* @see app/Http/Controllers/Banks/ProjectsController.php:49
* @route '//bank.finesthub.de/financing-requests'
*/
export const suggested = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: suggested.url(options),
    method: 'get',
})

suggested.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/financing-requests',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\ProjectsController::suggested
* @see app/Http/Controllers/Banks/ProjectsController.php:49
* @route '//bank.finesthub.de/financing-requests'
*/
suggested.url = (options?: RouteQueryOptions) => {
    return suggested.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\ProjectsController::suggested
* @see app/Http/Controllers/Banks/ProjectsController.php:49
* @route '//bank.finesthub.de/financing-requests'
*/
suggested.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: suggested.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::suggested
* @see app/Http/Controllers/Banks/ProjectsController.php:49
* @route '//bank.finesthub.de/financing-requests'
*/
suggested.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: suggested.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showRequest
* @see app/Http/Controllers/Banks/ProjectsController.php:94
* @route '//bank.finesthub.de/financing-requests/{projectSuggestion}'
*/
export const showRequest = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRequest.url(args, options),
    method: 'get',
})

showRequest.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/financing-requests/{projectSuggestion}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showRequest
* @see app/Http/Controllers/Banks/ProjectsController.php:94
* @route '//bank.finesthub.de/financing-requests/{projectSuggestion}'
*/
showRequest.url = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { projectSuggestion: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { projectSuggestion: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            projectSuggestion: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        projectSuggestion: typeof args.projectSuggestion === 'object'
        ? args.projectSuggestion.id
        : args.projectSuggestion,
    }

    return showRequest.definition.url
            .replace('{projectSuggestion}', parsedArgs.projectSuggestion.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showRequest
* @see app/Http/Controllers/Banks/ProjectsController.php:94
* @route '//bank.finesthub.de/financing-requests/{projectSuggestion}'
*/
showRequest.get = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRequest.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::showRequest
* @see app/Http/Controllers/Banks/ProjectsController.php:94
* @route '//bank.finesthub.de/financing-requests/{projectSuggestion}'
*/
showRequest.head = (args: { projectSuggestion: string | number | { id: string | number } } | [projectSuggestion: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showRequest.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Banks\ProjectsController::update
* @see app/Http/Controllers/Banks/ProjectsController.php:74
* @route '//bank.finesthub.de/financing-requests/{projectSuggestionId}'
*/
export const update = (args: { projectSuggestionId: string | number } | [projectSuggestionId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '//bank.finesthub.de/financing-requests/{projectSuggestionId}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Banks\ProjectsController::update
* @see app/Http/Controllers/Banks/ProjectsController.php:74
* @route '//bank.finesthub.de/financing-requests/{projectSuggestionId}'
*/
update.url = (args: { projectSuggestionId: string | number } | [projectSuggestionId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { projectSuggestionId: args }
    }

    if (Array.isArray(args)) {
        args = {
            projectSuggestionId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        projectSuggestionId: args.projectSuggestionId,
    }

    return update.definition.url
            .replace('{projectSuggestionId}', parsedArgs.projectSuggestionId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Banks\ProjectsController::update
* @see app/Http/Controllers/Banks/ProjectsController.php:74
* @route '//bank.finesthub.de/financing-requests/{projectSuggestionId}'
*/
update.put = (args: { projectSuggestionId: string | number } | [projectSuggestionId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const ProjectsController = { index, showNegotiation, suggested, showRequest, update }

export default ProjectsController